import React, { useState } from "react";
import { Row, Col, Button, Upload, Modal, message } from "antd";
import { FormAttributesProps, FormInputsObjectProps, FormRootElementAttributesProps } from "../../../types/formTypes";
import { handleSave, showButtons } from "../handle/formHandle";
import { downloadFile } from "../../../../components/util";

const { confirm } = Modal;

function showError(errors: string[] = []) {
    if (errors.length === 0) {
        return;
    }

    Modal.error({
        title: "Erro",
        content: (
            <div>
                {errors.map((it, idx) => (
                    <p key={idx}>{it}</p>
                ))}
            </div>
        ),
    });
}

interface QaFormButtonsProps {
    form?: FormInputsObjectProps;
    formAttributes: FormAttributesProps;
    rootElementAttributes?: FormRootElementAttributesProps;
    justSee?: boolean;
    onSave: (value?: string) => void;
    setTriedSave: (state: any) => void;
}

export interface ButtonsVisibleProps {
    save: boolean;
    print: boolean;
    temporarySave: boolean;
    localSave: boolean;
    reformulate: boolean;
    correctionList: boolean;
}
// select nome, xml, * from qa_formularios where xml not like '%botoes="topo"%' and xml not like '%tipo="subformulario"%'
// and xml not like '%ignora_dados="sim"%' and xml not like '%consulta_formulario%'
// and xml not like '%botoes="botoes_subformulario"%'
const QaFormButtonActions = ({
    form,
    formAttributes,
    onSave,
    rootElementAttributes,
    justSee,
    setTriedSave,
}: QaFormButtonsProps) => {
    const [saving, setSaving] = useState(false);
    const [tempSaving, setTempSaving] = useState(false);

    const toggleLoadSave = (temporary = false) => {
        if (temporary) {
            setTempSaving((prev) => !prev);
        } else {
            setSaving((prev) => !prev);
        }
    };

    const onClickSave = async (temporary = false) => {
        toggleLoadSave(temporary);

        if (!temporary) {
            setTriedSave(true);
        }

        const result = await handleSave(form!, formAttributes, temporary);

        if (result.status === "SUCCESS") {
            const resp = result.response;
            if (!resp || resp.sucesso === "0") {
                message.error("Ocorreu um erro");
                toggleLoadSave(temporary);
            } else {
                // sucesso
                message.success("Guardado com sucesso");

                if (rootElementAttributes?.report || resp.notificacao) {
                    showNotificationAndReport(resp.sucesso, resp.notificacao);
                } else {
                    if (onSave && typeof onSave === "function") {
                        onSave(resp.sucesso);
                    }
                }
            }
        } else {
            if (result.status === "ERROR") {
                message.error(result.message || "Ocorreu um erro");
            } else if (!result.status) {
                if (result?.errors) {
                    showError(result.errors);
                }
            }
            toggleLoadSave(temporary);
        }
    };

    // ------------- Notification and print report on save ------------------------------------------------
    const showConfirmPrintReport = (formId: string) => {
        if (rootElementAttributes?.report) {
            confirm({
                title: "Descarregar documento?",
                onOk() {
                    downloadFile("/gererelatorios.php", {
                        accao: "relatorio_nome",
                        nome: rootElementAttributes?.report,
                        saida: "pdf",
                        id: formId,
                        downloadInBrowser: true,
                    });
                    onSave(formId);
                },
                onCancel() {
                    onSave(formId);
                },
            });
        } else {
            onSave(formId);
        }
    };

    const showNotificationAndReport = (formId: string, notification: string) => {
        if (notification) {
            Modal.confirm({
                title: "Notificação",
                content: <pre>{notification}</pre>,
                className: "email_info",
                okText: "Ok",
                okType: "primary",
                cancelButtonProps: {
                    hidden: true,
                },
                onOk() {
                    showConfirmPrintReport(formId);
                },
            });
        } else {
            showConfirmPrintReport(formId);
        }
    };

    const buttonVisible = showButtons(rootElementAttributes, justSee);

    return (
        <>
            <Row gutter={18} style={{ marginTop: 16 }}>
                <Col xs={24} sm={12}>
                    <div className="qa-group-actions-left">
                        {buttonVisible.save && (
                            <>
                                <Button loading={saving} type="primary" icon="save" onClick={() => onClickSave()}>
                                    Guardar
                                </Button>
                            </>
                        )}

                        {buttonVisible.temporarySave && (
                            <Button icon="save" onClick={() => onClickSave(true)} loading={tempSaving}>
                                Guardar Temporário
                            </Button>
                        )}
                    </div>
                </Col>

                <Col xs={24} sm={12}>
                    <div className="qa-group-actions-right">
                        {buttonVisible.reformulate && (
                            <Button icon="undo" type="danger" ghost>
                                Reformular
                            </Button>
                        )}
                        {buttonVisible.localSave && (
                            <>
                                <Upload className="load-local">
                                    <Button icon="cloud-upload" htmlType="submit">
                                        Carregar Local
                                    </Button>
                                </Upload>

                                <Button icon="cloud-download">Gravar Local</Button>
                            </>
                        )}
                    </div>
                </Col>
            </Row>
        </>
    );
};

export const QaFormActions = QaFormButtonActions;
